import { IPoolMatrixToteResponse } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matrixData',
  standalone: true,
})
export class MatrixDataPipe implements PipeTransform {

  transform(value: IPoolMatrixToteResponse | null, index: number, type?: 'percent' | 'odd' | 'total' | 'onePays'): string | number {

    const runnerTotal = value?.Rows[0]?.Columns[index]?.Total;
    const poolTotal = value?.Total;

    // Win price normalised to a $1 base wager
    if (type === 'onePays') {
      const price = value?.Rows[0]?.Columns[index]?.Price;
      const base = value?.PriceBaseWager;
      return price && base ? (price / base).toFixed(1) : '-';
    }

    return (type === 'percent') && runnerTotal && poolTotal
      ? (runnerTotal/poolTotal*100).toFixed() + "%"
      : (type === 'percent')
        ? '-'
        : (type === 'odd')
          ? value?.Rows[0]?.Columns[index]?.Formatted || '-'
          // total
          : value?.Rows[0]?.Columns[index]?.Total || '0'
  }

}
